import React from 'react';
import { Typography, Card, CardContent, CardMedia, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import Carousel from './Carousel';
import { generatePlaceholderImage } from '../utils/imageUtils';
import { useMeta } from '../contexts/MetaContext';

const RecentlyViewed = ({ products }) => {
  const { metaData } = useMeta();
  
  // Don't render if no products
  if (!products || products.length === 0) {
    return null;
  }

  const carouselItems = products.map(product => ({
    label: product.name,
    imgPath: product.image,
    content: (
      <Card 
        component={Link} 
        to={`/product/${product.id}`} 
        sx={{ 
          textDecoration: 'none',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 'none',
          p: 1,
          textAlign: 'center',
        }}
      >
        <Box sx={{ position: 'relative', paddingTop: '100%' }}>
          <CardMedia 
            component="img" 
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            src={`${metaData.imageCdn}/img/product/${product.id}/1.jpg`}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = generatePlaceholderImage(300, 300, product.name);
            }}
            alt={product.name}
          />
        </Box>
        <CardContent sx={{ flexGrow: 1, p: 1 }}>
          <Typography 
            variant="caption"
            color="text.secondary" 
            gutterBottom 
            sx={{ textTransform: 'uppercase' }}
          >
            {product.brand}
          </Typography>
          <Typography 
            gutterBottom 
            variant="subtitle1"
            component="div" 
            noWrap
          >
            {product.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ${product.price}
          </Typography>
        </CardContent>
      </Card>
    )
  }));

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Recently Viewed</Typography>
      <Carousel items={carouselItems} itemsPerStep={{ xs: 2, sm: 3, md: 4 }} />
    </Box>
  );
};

export default RecentlyViewed;